export default __webpack_public_path__ + "23f606549675c3bff89a26ae630c1be4.png";